// extracted by mini-css-extract-plugin
export default {"root":"DerogatorySection_root__JAW2D","sectionLabel":"DerogatorySection_sectionLabel__Wd-wh"};